export enum IChartererTabs {
  addNewCharterer = "1",
  chartererTable = "2",
}
